import type { SystemUserRow, UserListApiItem } from "./types";

function formatLoginTime(value?: number | null): string {
    if (value === undefined || value === null || value <= 0) return "--";
    const ms = value > 1e12 ? value : value * 1000;
    const date = new Date(ms);
    if (Number.isNaN(date.getTime())) return "--";
    const pad = (n: number) => String(n).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

/** 将后端 list item 映射为表格行 */
export function mapUserListItemToRow(item: UserListApiItem): SystemUserRow {
    return {
        id: item.id,
        corpId: item.corpId,
        corpName: item.corpName || "",
        username: item.username,
        nick: item.nick || "",
        tel: item.tel || "",
        email: item.email || "",
        roleIds: item.roleIds,
        roleNames: item.roleNames ?? [],
        status: item.status,
        statusLabel: item.statusLabel || "",
        loginCount: item.loginCount ?? 0,
        lastLoginIp: item.lastLoginIp || "",
        ipProvince: item.ipProvince || "",
        ipCity: item.ipCity || "",
        lastLoginTime: formatLoginTime(item.lastLoginTime),
        creatorName: item.creatorName || "",
        createTime: item.createTime || "",
    };
}
